import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectIsReadLocked} from "../store/auth/authSelector";
import {loadCommonAction} from "../store/common/commonActions";

/**
 * Starts loading the common data of the app (studio, artists, ...) for pages behind the login.
 *
 * A guest on an unknown device may not even read until the device is unlocked with a code (`readLocked` in the
 * access token): every request would fail with 403. So nothing is loaded and nothing is to be shown
 * (`isDataLocked`) before that; unlocking the device changes `readLocked` and so loads the app.
 *
 * @param {boolean} isPublicRoute pages that need no login (login, reset password, signup) load nothing
 * @returns {{isDataLocked: boolean}}
 */
export const useCommonDataBootstrap = ({isPublicRoute}) => {
    const dispatch = useDispatch();
    const isReadLocked = useSelector(selectIsReadLocked);
    const isDataLocked = !isPublicRoute && isReadLocked;

    useEffect(() => {
        if (!isPublicRoute && !isReadLocked) {
            dispatch(loadCommonAction());
        }
    }, [dispatch, isPublicRoute, isReadLocked]);

    return {isDataLocked};
};
